/*********************************************************
 * Copyright (C) 2015-2017 VMware, Inc. All rights reserved.
 *********************************************************/
/**
 * @fileoverview rtavconstants.js -- constants
 * object holds RTAV related constants
 */

import RTAV from './logservice';

const constants = {
   AVPluginState: {
      STChannelClose: 0,
      STChannelOpen: 1,
      STOff: 2,
      STOn: 3,
      STPending_AIn: 4,
      STEnabled_AIn: 5,
      STEnabled_V: 6,
      STEnabled_VAIn: 7,
      STError: 8
   },
   rtavTypes: {
      PMsgGetConfig: 4,
      PMsgSetConfig: 5,
      PMsgGetCliSettings: 6,
      PMsgSetCliSettings: 7,
      PMsgStart_A: 8,
      PMsgStart_A_Ack: 9,
      PMsgStart_A_Ack_Err: 10,
      PMsgStop_A: 11,
      PMsgStop_A_Ack: 12,
      PMsgStop_A_Ack_Err: 13,
      PMsgStart_V: 14,
      PMsgStart_V_Ack: 15,
      PMsgStart_V_Ack_Err: 16,
      PMsgStop_V: 17,
      PMsgStop_V_Ack: 18,
      PMsgStop_V_Ack_Err: 19,
      PMsgStartStream: 21,
      PMsgStopStream: 22,
      PMsgBinData: 24
   },
   codecTypes: {
      CodecNone: 0,
      CodecSpeex: 1,
      CodecTheora: 2,
      CodecTheoraSpeex: 3,
      CodecVmwSpeex: 4,
      CodecVmwTheora: 5,
      CodecVmwTheoraSpeex: 6,
      CodecVmwH264: 7,
      CodecVmwH264Speex: 8,  // For H264 and speex
      CodecVmwOpus: 9, // Opus codec for audio will be done by 24FQ3
      CodecVmwH264Opus: 10,   // For H264 and Opus, which will be done by 24FQ3
   },
   streamHeaderLength: 16
};

RTAV.constants = constants;